import { validatePhoneForLocale } from './phone.utils'

export const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const phoneNumberPattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
// US/CA default national-number pattern. Locale-aware consumers should build the
// pattern from the locale config via getPhoneNumberPattern (see phone.utils).
export const mobileNumberPattern = /^[0-9]{10}$/

// Phone number formatting templates
const PHONE_FORMAT_PARTIAL = '($1) $2'
const PHONE_FORMAT_FULL = '($1) $2-$3'

export function formatPhoneNumber(phoneNumber) {
  const pNumber = phoneNumber?.replace(/\D/g, '') || ''

  if (pNumber.length <= 3) {
    return pNumber
  } else if (pNumber.length <= 6) {
    return pNumber.replace(/(\d{3})(\d{1,3})/, PHONE_FORMAT_PARTIAL)
  } else {
    return pNumber.replace(/(\d{3})(\d{3})(\d{1,4})/, PHONE_FORMAT_FULL)
  }
}

export function removePhoneNumberFormat(phoneNumber) {
  const pNumber = phoneNumber?.replace('+1', '').replace(/\D/g, '')
  return pNumber
}

export const validateEmail = val => {
  return emailPattern.test(val)
}

/**
 * Validate a phone number for the given locale.
 *
 * Delegates to the config-driven validator in phone.utils, which strips the
 * locale dial code and checks the national-digit count against the locale's
 * `phoneNumberLength`. The locale config must be resolved at the React layer
 * (e.g. from `useLocaleContext()` / `useStatsigDynamicLocaleConfig()`) and
 * passed in — this util never reads the locale itself. When no config is
 * supplied, phone.utils falls back to the US/CA 10-digit rule.
 *
 * @param {string} val - Raw phone input (may include dial code, spaces, formatting)
 * @param {import('@src/config/localisation/statsig-locale-config.types').StatsigLocaleDynamicConfig} [localeConfig]
 * @returns {boolean}
 */
export const validatePhone = (val, localeConfig) => validatePhoneForLocale(val, localeConfig)
